<template>
    <div class="text-box" v-if="isInit">
        <el-form
            ref="form"
            :model="field"
            :label-width="field.name ? '120px' : '0'"
        >
            <el-form-item
                class="input-row"
                :label="field.desc"
                prop="def_val"
                :rules="fieldRules"
            >
                <div v-if="field.name" slot="label" class="label-item common">
                    <p class="label-text">{{ field.desc }}</p>
                    <el-tooltip
                        class="item"
                        effect="light"
                        placement="bottom-start"
                    >
                        <div slot="content">
                            - name: <strong>{{ field.name }}</strong
                            ><br />
                        </div>
                        <i class="label-icon el-icon-info"></i>
                    </el-tooltip>
                </div>
                <el-input class="field-input" :value="field.def_val" :placeholder="`请填写${field.desc || '此处'}的内容`" @input="valChangeHandler"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from "moment";

export default {
    name: "text-box",
    props: ["field", "autoInit"],
    data() {
        return {
            // resField: this.field,
            fieldRules: {
                required: this.field.require,
                message: `请填写'${this.field.desc}'的内容`,
                trigger: "blur"
            },
            isInit: this.autoInit
        };
    },
    components: {},
    watch: {},
    methods: {
        valChangeHandler(val) {
            // 适配基本类型数据的变更
            this.field.def_val = val;
            //this.$emit('update:field', Object.assign({}, this.field, {def_val: val}));
            this.$emit('val-change', val);
        },
        initData() {
            this.isInit = true;
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs["form"].validate(valid => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        }
    },
    computed: {},
    mounted() {}
};
</script>
<style lang="less">
@import (reference) "../../styles/public.less";
.text-box {
    .label-item();
}
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/textBox.vue